<template>
  <!-- 招贤纳士 -->
  <div>
    <!-- banner -->
    <img src="../../static/join/join.png" alt="img" class="img" />
    <!-- content -->
    <div class="content">
      <div class="join-title">我们渴望人才、尊重人才，期待您的加入</div>
      <div class="tips">查看以下岗位</div>
      <div class="post-list">
        <div class="item-post">
          <div class="item-post-title-wrap">
            <div class="item-post-title">销售精英（数名）</div>
          </div>
          <div class="item">
            <div class="item-post-desc">
              <div class="title">招聘岗位：</div>
              <div class="item-data">销售精英（数名）</div>
            </div>
            <div class="item-post-responsibility">
              <div class="title">岗位职责：</div>
              <div
                class="item-data"
                v-for="(item, index) in responsibility"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="item-post-require">
              <div class="title">任职要求：</div>
              <div
                class="item-data"
                v-for="(item, index) in requiredList"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 投递邮箱 -->
      <div class="email">投递邮箱：wangxiuqin@uspacetech.com</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      responsibility: [
        "工作地点：（全国）",
        "1、负责相关地区产品销售工作；",
        "2、推行实施销售计划；",
        "3、负责完成销售任务、回款任务及跟进工作；",
        "4、定期拜访客户，了解客户动态；",
        "5、定期对客户档案进行分析、整理，提供销售分析数据；",
        "6、参与合同的谈判和签订；",
        "7、参与方案的编写工作及各项目招投标事宜；",
        "8、参与全国及地区各类学术推广；",
        "9、积极参加公司组织的各项销售活动，维护企业利益和荣誉。",
      ],
      requiredList: [
        "1、具备医疗软件销售3年以上工作经验者优先；",
        "2、可适应短期出差以及长期驻点；",
        "3、全日制大学本科及以上学历，市场营销/医学/信息化相关专业优先考虑大专以上学历（具有相关销售经验丰富者可适当放宽酌情考虑）；",
        "4、性格外向、普通话标准，有较强的沟通能力与交际技巧；",
        "5、具备一定的市场分析及判断能力，有良好的客户服务意思；",
        "6、熟悉办公软件操作（word、excel、powerpoint）；",
        "7、个人形象佳，不限男女。",
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  .join-title {
    text-align: center;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 50px;
  }
  .tips {
    margin-top: 32px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-bottom: 73px;
  }
  .post-list {
    .item-post {
      .item-post-title-wrap {
        width: 1200px;
        height: 67px;
        background: #f8f9fd;
        display: flex;
        align-items: center;
        padding-left: 40px;
        .item-post-title {
          background: #989caf;
          color: #fff;
          border-radius: 16px;
          padding: 5px 14px 5px 18px;
        }
      }
      .item {
        margin-top: 24px;
        margin-left: 43px;
        .item-post-desc {
          margin-bottom: 38px;
        }
        .item-post-responsibility {
          margin-bottom: 38px;
        }
        .item-post-require {
          margin-bottom: 87px;
        }
      }
    }
  }
  // 邮箱
  .email {
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 50px;
  }
}
.title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 18px;
}
.item-data {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.img {
  width: 100%;
}
</style>
